import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Tooltip } from '../../../components/Tooltip';

export const StyledInsightsHeading = styled.h2`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  ${setFontVariant('h6', colorsPalettes.carbon[500])};
  font-weight: 300;
  margin: 0;
`;

export const StyledSamLogo = styled.svg`
  width: 34px;
  height: 18px;
  margin-right: 6px;
  align-self: flex-start;
`;

export const StyledContactName = styled.span`
  color: ${colorsPalettes.carbon[400]};
  text-decoration: underline;
  white-space: nowrap;
  font-weight: 400;
`;

export const StyledContactDetailsTooltip = styled.div`
  margin: 8px;
  display: flex;
  flex-direction: column;
`;

export const StyledContactPosition = styled.span`
  ${setFontVariant('report', colorsPalettes.carbon[400])};
  font-size: 13px;
`;

export const StyledContactCountry = styled.span`
  ${setFontVariant('report', colorsPalettes.carbon[250])};
  font-size: 11px;
`;

export const StyledCompanyName = styled.div`
  margin-left: 3px;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  font-weight: 400;
`;

export const StyledCompanyFavicon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const StyledContactTooltip = styled(Tooltip)`
  cursor: default;
`;
